type Props = {
  text: string;
  selected: boolean;
  onClick: () => void;
};

export const CustomRegionButton = ({ text, selected, onClick }: Props) => {
  return (
    <button
      className={`px-3 py-1 ${selected ? "bg-brand700 text-white" : "bg-white text-gray-700"} focus:outline-hidden`}
      onClick={onClick}
    >
      {text}
    </button>
  );
};
